import logo from './logo.svg';
import './App.css';
import HeaderRoutes from './headerComponent/HeaderRoutes';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store'

function App() {
  return (
    <HashRouter>
    <Provider store={store}>
      <HeaderRoutes />
    </Provider>
  </HashRouter>
  );
}

export default App;
